import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { BaseFiltroPaginate } from "core/resources/enums/paginate";

export interface useGetTenantUsuariosSimplesProps extends PaginateQuery {
  tenantId: string;
  perfilId?: string;
}

function useGetTenantUsuariosSimples({
  tenantId,
  page = 1,
  limit = BaseFiltroPaginate.Limit,
  search = undefined,
  perfilId,
}: useGetTenantUsuariosSimplesProps) {
  return useQuery(
    [`/v1/tenants/${tenantId}/usuarios/simples-${page}-${limit}-${search}-${perfilId}`],
    async () => {
      const res = await axios.get<PaginateResult<{id: string; nome: string;}>>(
        `/v1/tenants/${tenantId}/usuarios/simples`,
        {
          params: {
            page,
            limit,
            search,
            perfilId,
          },
        }
      );

      return res.data;
    }
  );
}

export default useGetTenantUsuariosSimples;
